import Vue from 'vue';
import debounce from 'lodash/debounce';
export default Vue.extend({
    name: 'ChannelVideoSearchField',
    props: {
        value: String,
    },
    data() {
        return {
            hasFocus: false,
            search: this.$props.value,
        };
    },
    methods: {},
    watch: {
        search: debounce(function (search) {
            this.$emit('input', search);
        }, 300),
    },
});
